import {
  type AfterViewChecked,
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[libCommonUiComponentsTextInputAutosize]',
  standalone: false,
})
export class CommonUiComponentsTextInputAutosizeDirective
  implements AfterViewChecked
{
  @Input() maxRows = 5;

  @Input() minRows = 1;

  constructor(
    private element: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewChecked() {
    this.updateHeight();
  }

  @HostListener('input') onInput() {
    this.updateHeight();
  }

  private updateHeight() {
    this.renderer.setStyle(this.element.nativeElement, 'height', '16px');

    const { scrollHeight } = this.element.nativeElement as Element;
    let newHeight = '';

    if (this.maxRows && this.minRows) {
      const lineHeight = 16;
      const maxHeight = lineHeight * this.maxRows;
      const minHeight = lineHeight * this.minRows;
      newHeight = `${Math.min(maxHeight, Math.max(minHeight, scrollHeight))}px`;
      this.renderer.setStyle(
        this.element.nativeElement,
        'max-height',
        `${maxHeight.toString()}px`
      );
      this.renderer.setStyle(
        this.element.nativeElement,
        'min-height',
        `${minHeight.toString()}px`
      );
    } else {
      newHeight = `${scrollHeight}px`;
    }

    this.renderer.setStyle(this.element.nativeElement, 'height', newHeight);
  }
}
